<template>
<div class="no_limit_apply">
    <OtherHead :tipText="$t('没有访问权限')"></OtherHead>
    <div class="empty_content">
      <ApplyAuthView :message="$t('没有访问权限')" :fileId="doc_id" :owner="doc_info.fileInfo?.creator" :auth="doc_info.auth" :contentType="contentType"></ApplyAuthView>
    </div>
  </div>
</template>

<script lang="ts">
import OtherHead from './OtherHead.vue'
import ApplyAuthView from '../share/ApplyAuthView.vue'
import { mapState } from 'vuex'
export default {
  name: 'no_limit',
  components: {
    OtherHead,
    ApplyAuthView
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      doc_id: state => state.kbModule.doc_id,
      doc_info: state => state.kbEditModule.doc_info
    }),
    contentType() {
      return this.doc_info?.fileInfo?.contentType || ''
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.no_limit_apply {
  flex: 1;
  display: flex;
  flex-direction: column;

  .empty_content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .apply-auth {
      background-color: unset !important;
    }

    img {
      width: 127px;
    }

    .empty_text {
      margin-top: 16px;
      height: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #a2a4b0;
      text-align: center;
    }
  }
}
</style>
